import * as Preact from "preact"
import Chapter from "@frog/source/models/Chapter.js"
import games from "@frog/source/data/games/index.js"

import Navigation from "@frog/source/engine/navigating/Navigation.js"
import Camera from "@frog/source/views/components/Camera.jsx"
import Unit from "@frog/source/views/components/Unit.jsx"
import App from "@frog/source/models/App.js"
import Step from "@frog/source/models/Step.js"

import "@frog/source/views/dev/DevSavetestScreen.less"

export default class DevSavetestScreen {
    render() {
        return (
            <div class="DevTestScreen" status={Navigation.state.test.status}>
                <title>Frog Test</title>
                <div class="TestSlug">{Navigation.state.test.memo || Navigation.state.test.name}</div>
                <div class="Message">{Navigation.state.test?.error?.message}</div>
                <div class="DifferenceComparison">
                    <div class="Column">
                        Replay
                        <StageReplay demo={Navigation.state.test}/>
                    </div>
                    <div class="Column">
                        Saved
                        <StageSnapshot demo={Navigation.state.test}/>
                    </div>
                </div>
            </div>
        )
    }
}

class StageSnapshot {
    constructor(props) {
        this.loadDemonstrationChapter(props.demo)
    }
    loadDemonstrationChapter(demo) {
        if(demo == undefined) {
            App.snapshotChapter = undefined
            return
        }
        App.snapshotChapter = Chapter.load({
            "chapter": games[demo.gameSlug].chapters[demo.chapterSlug],
            "player": demo.player,
            "gameslug": demo.gameSlug,
            "randomSeed": demo.randomSeed,
        }, {"isBlockingSideEffects": true, "animationSequence": {"steps": []}})
        const chapter = App.snapshotChapter
        chapter.sequence = []
        const step = Step.instantiate({
            "alphastage": chapter.stage,
            "deltastage": demo.deltastageSum,
        })
        chapter.stage = step.omegastage
        chapter.selection.camera.position.z = 0.25
    }
    render() {
        return (
            <div class="Preview">
                <Stage chapter={App.snapshotChapter}/>
            </div>
        )
    }
}

class StageReplay {
    constructor(props) {
        this.loadDemonstrationChapter(props.demo)
    }
    loadDemonstrationChapter(demo) {
        if(demo == undefined) {
            App.previewChapter = undefined
            return
        }
        App.previewChapter = Chapter.load({
            "chapter": games[demo.gameSlug].chapters[demo.chapterSlug],
            "player": demo.player,
            "gameslug": demo.gameSlug,
            "randomSeed": demo.randomSeed,
        }, {"isBlockingSideEffects": true, "animationSequence": {"steps": []}})
        App.previewChapter.replaySavestateFromActiontrace(demo, {"isShowingEveryStep": true})
        //App.previewChapter.sequence.isLooping = true
        App.previewChapter.selection.camera.position.z = 0.25
    }
    render() {
        return (
            <div class="Preview"
                onClick={() => this.loadDemonstrationChapter(this.props.demo)}>
                <Stage chapter={App.previewChapter}/>
            </div>
        )
    }
}

class Stage {
    render() {
        if(this.props.chapter == undefined) return
        const stage = this.getActiveStage()

        return (
            <div class="Stage">
                <Camera chapter={this.props.chapter}>
                    <WorldImage stage={stage}/>
                    <Units stage={stage}/>
                </Camera>
            </div>
        )
    }
    getActiveStage() {
        const sequence = this.props.chapter.sequence

        if(sequence != undefined
        && sequence.steps != undefined
        && sequence.steps[0] != undefined
        && sequence.steps[0].stage != undefined) {
            return sequence.steps[0].stage
        }
        if(sequence != undefined
        && sequence.steps != undefined
        && sequence.steps[0] != undefined
        && sequence.steps[0].omegastage != undefined) {
            return sequence.steps[0].omegastage
        }
        return this.props.chapter.stage
    }
}

class Units {
    render() {
        const stage = this.props.stage
        return Object.values(stage.units).map((unit, index) => {
            if(unit == undefined) return
            if(unit.isDead == true) return
            if(unit.isRemoved == true) return
            if(unit.isNotRendered) return

            return <Unit stage={stage} unit={unit}/>
        })
    }
}

class WorldImage {
    render() {
        if(this.props.stage.images != undefined) {
            return this.props.stage.images.map((image, index) => {
                return (
                    <div class="WorldImage" style={{
                        "background-image": "url(" + (image.url || image) + ")",
                        "width": this.props.stage.world.width + "em",
                        "height": this.props.stage.world.height + "em",
                        "z-index": 1 + (index * 10) + (image.z - 1) * 100,
                        "mix-blend-mode": image.effect,
                    }}/>
                )
            })
        }
        return (
            <div class="WorldImage" style={{
                "background-image": "url(" + this.props.stage.image + ")",
                "width": this.props.stage.world.width + "em",
                "height": this.props.stage.world.height + "em",
            }}>
                {this.encounters}
            </div>
        )
    }
    get encounters() {
        if(this.props.stage.encounters == undefined) return
        return Object.values(this.props.stage.encounters).map((encounter) => {
            if(this.props.stage.currentEncounterKey < encounter.slug) return
            if(encounter.color == undefined) return
            return (
                <div class="EncounterImage" style={{
                    "width": encounter.width + "em",
                    "height": encounter.height + "em",
                    "left": encounter.x + "em",
                    "top": encounter.y + "em",
                    "backgroundColor": encounter.color,
                }}/>
            )
        })
    }
}
